import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ReversePipe } from 'projects/common/pipes/reverse.pipe';
import { DualPromoComponent } from './dual-promo.component';
import { TooltipModule } from '@shopping-angular-components/tooltip';


@NgModule({
    imports: [CommonModule, TranslateModule, TooltipModule],
    exports: [DualPromoComponent, ReversePipe],
    declarations: [DualPromoComponent, ReversePipe],
    providers: [],
})
export class DualPromoModule { }
